if (!customElements.get('withdrawal-form')) {
  class WithdrawalForm extends HTMLElement {
    constructor() {
      super();

      this.labels = {
        orderNumber: 'Order number',
        orderDate: 'Order date',
        items: 'Items to withdraw from',
        message: 'Additional details',
        requestType: 'EU Right of Withdrawal',
      };
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.step1 = this.querySelector('[data-step="1"]');
      this.step2 = this.querySelector('[data-step="2"]');
      this.continueButton = this.querySelector('[data-withdrawal-continue]');
      this.backButton = this.querySelector('[data-withdrawal-back]');
      this.confirmButton = this.querySelector('[data-withdrawal-confirm]');
      this.hiddenName = this.querySelector('#WithdrawalForm-hidden-name');
      this.hiddenEmail = this.querySelector('#WithdrawalForm-hidden-email');
      this.hiddenBody = this.querySelector('#WithdrawalForm-hidden-body');
      this.messageReviewRow = this.querySelector('[data-review-row="message"]');

      this.loadLabels();
      this.continueButton?.addEventListener('click', this.handleContinue.bind(this));
      this.backButton?.addEventListener('click', this.handleBack.bind(this));
      this.confirmButton?.addEventListener('click', this.populateHiddenFields.bind(this));
    }

    loadLabels() {
      const continueButton = this.continueButton;
      if (!continueButton) return;

      const formSection = this.closest('.withdrawal');
      if (!formSection) return;

      this.labels.orderNumber =
        formSection.querySelector('#WithdrawalForm-order-number')?.placeholder ||
        this.labels.orderNumber;
      this.labels.orderDate =
        formSection.querySelector('#WithdrawalForm-order-date')?.placeholder ||
        this.labels.orderDate;
      this.labels.items =
        formSection.querySelector('#WithdrawalForm-items')?.placeholder ||
        this.labels.items;
      this.labels.message =
        formSection.querySelector('#WithdrawalForm-message')?.placeholder ||
        this.labels.message;
    }

    getFieldValue(fieldName) {
      const field = this.querySelector(`[data-withdrawal-field="${fieldName}"]`);
      return field ? field.value.trim() : '';
    }

    setReviewValue(fieldName, value) {
      const target = this.querySelector(`[data-review="${fieldName}"]`);
      if (target) target.textContent = value;
    }

    validateStep1() {
      const requiredFields = this.step1.querySelectorAll('[required]');
      let isValid = true;

      for (const field of requiredFields) {
        if (!field.checkValidity()) {
          isValid = false;
          field.reportValidity();
          break;
        }
      }

      return isValid;
    }

    handleContinue(event) {
      event.preventDefault();
      if (!this.validateStep1()) return;

      const values = {
        name: this.getFieldValue('name'),
        email: this.getFieldValue('email'),
        order_number: this.getFieldValue('order_number'),
        order_date: this.getFieldValue('order_date'),
        items: this.getFieldValue('items'),
        message: this.getFieldValue('message'),
      };

      Object.entries(values).forEach(([key, value]) => {
        this.setReviewValue(key, value);
      });

      if (values.message) {
        this.messageReviewRow?.classList.remove('hidden');
      } else {
        this.messageReviewRow?.classList.add('hidden');
      }

      this.step1.classList.add('hidden');
      this.step1.hidden = true;
      this.step2.classList.remove('hidden');
      this.step2.hidden = false;
      this.step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    handleBack(event) {
      event.preventDefault();

      this.step2.classList.add('hidden');
      this.step2.hidden = true;
      this.step1.classList.remove('hidden');
      this.step1.hidden = false;
      this.step1.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    buildMessage(values) {
      const lines = [
        'shopify withdrawal notice',
        '------------------------------',
        `Name: ${values.name}`,
        `Email: ${values.email}`,
        `Order number: ${values.order_number}`,
        `Order date: ${values.order_date}`,
        '',
        'Products:',
        values.items,
      ];

      if (values.message) {
        lines.push('', 'Additional details:', values.message);
      }

      lines.push('', `Submitted at: ${new Date().toISOString()}`);

      return lines.join('\n');
    }

    populateHiddenFields() {
      const values = {
        name: this.getFieldValue('name'),
        email: this.getFieldValue('email'),
        order_number: this.getFieldValue('order_number'),
        order_date: this.getFieldValue('order_date'),
        items: this.getFieldValue('items'),
        message: this.getFieldValue('message'),
      };

      if (!values.name || !values.email || !values.order_number || !values.order_date || !values.items) {
        this.handleBack({ preventDefault() {} });
        this.validateStep1();
        return;
      }

      this.hiddenName.value = values.name;
      this.hiddenEmail.value = values.email;
      this.hiddenBody.value = this.buildMessage(values);
    }
  }

  customElements.define('withdrawal-form', WithdrawalForm);
}
